//import Uiconstants from "../../lib/UIconstants"
import { isDesktop } from 'react-device-detect';
import CloseController from '../../controllers/CloseController';
import BonusBuyPageController from '../../controllers/bonus/BonusBuyPageController';
import MainGridController from '../../controllers/grid/MainGridController';
import { COMPONENTS } from '../../lib/constants';
import { BonusBuyGridView } from './BonusBuyGridView';
let scale = isDesktop ? 1 : 2;
export const BonusPageView = {
	name: COMPONENTS.BONUS_BUY_PAGE,
	child: true,
	position: {
		x: 0,
		y: 0
	},
	controllers: [
		{
			Controller: CloseController,
			name: 'CloseController',
			config: {
				closeBtn: 'close',
				remove: true,
				holder: 'bonus_buy_holder'
			}
		},
		{
			Controller: BonusBuyPageController,
			name: 'BonusBuyPageController',
			config: {
				items: [
					'BONUS_BUY_DIALOG_FREESPIN_COST',
					'BONUS_BUY_DIALOG_FREESPIN_AMOUNT'
				],
				holder: 'bonus_buy_holder'
			}
		},
		{
			Controller: MainGridController,
			name: 'BonusBuyPageGridController',
			config: BonusBuyGridView
		}
	],
	components: [
		{
			name: 'bonus_buy_holder',
			type: 'Sprite',
			components: [
				{
					name: 'bg',
					type: 'Sprite',
					img: 'dialog_main_bg',
					position: { x: 0, y: 0 },
					alpha: 0.9,
					scale: { x: scale, y: scale }
				},
				{
					name: 'header',
					type: 'CustomText',
					text: 'BONUS_BUY_DIALOG_HEADER',
					position: { x: 634 / 2, y: 18 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'BONUS_BUY_DIALOG_DESCRIPTION_0',
					type: 'Text',
					text: 'BONUS_BUY_DIALOG_DESCRIPTION_0',
					position: { x: 634 / 2, y: 90 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'BONUS_BUY_DIALOG_FREESPIN_AMOUNT',
					type: 'CustomText',
					text: 'BONUS_BUY_DIALOG_FREESPIN_AMOUNT',
					position: { x: 120, y: 150 }
				},
				{
					name: 'BONUS_BUY_DIALOG_DESCRIPTION_1',
					type: 'Text',
					text: 'BONUS_BUY_DIALOG_DESCRIPTION_1',
					position: { x: 634 / 2 + 15, y: 150 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'BONUS_BUY_DIALOG_FREESPIN_COST',
					type: 'CustomText',
					text: 'BONUS_BUY_DIALOG_FREESPIN_COST',
					position: { x: 634 / 2, y: 230 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'close',
					type: 'ActionButton',
					bg: 'dialog_no_btn',
					text: 'BONUS_BUY_DIALOG_NO_BTN',
					position: { x: 230, y: 353 }
				},
				{
					name: 'yes_btn_wrapper',
					type: 'Sprite',
					components: [
						{
							name: 'yes_btn',
							type: 'ActionButton',
							bg: 'dialog_yes_btn',
							text: 'BONUS_BUY_DIALOG_YES_BTN',
							position: { x: 390, y: 353 }
						}
					]
				}
			]
		}
	]
};
